module.exports = __webpack_public_path__ + "static/media/table-2.3732ac78.jpg";